import {adServingPartnersApi} from 'common/src/modules/adServingPartner/adServingPartner.api';
import convertDspToAiString from 'common/src/modules/adServingPartner/copilot/utils/convertDspToAiString';
import buildDspResourceLink from 'common/src/modules/adServingPartner/copilot/utils/buildDspResourceLink';
import {AdservingPartnerWithMacros} from 'common/src/modules/adServingPartner/adServingPartner.types';
import {ResourceKnowledgeConfig} from 'common/src/modules/shared/copilot/tools/resourceKnowledgeTool/resourceKnowledgeTool.types';

const dspResourceConfig: ResourceKnowledgeConfig<AdservingPartnerWithMacros> = {
  searchFunction: async (searchPrompt: string) => {
    const {dsps, filtersExplanation} =
      await adServingPartnersApi.searchDspsWithEmbeddings(searchPrompt);

    return {resources: dsps, filtersExplanation};
  },
  formatter: convertDspToAiString,
  linkBuilder: buildDspResourceLink,
  additionalInstructions: `- If you are asked whether a DSP is certified, then you should answer only yes or no, based on whether the DSP was found.
- If you are asked about macros, answer with the macro value and the Clinch variable name, in a markdown table format.`,
  description: 'DSPs and their certification status',
};

export {dspResourceConfig};
